module.exports = __webpack_public_path__ + "img/yyjjfa_05.54201e99.jpg";